/* Read more about this here 
https://styled-components.com/docs/faqs#shouldforwardprop-is-no-longer-provided-by-default
We need to remove this component once we move to transient props */
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

// This implements the default behavior from styled-components v5
function shouldForwardProp(propName, target) {
	if (typeof target === 'string') {
		// For HTML elements, forward the prop if it is a valid HTML attribute
		return isPropValid(propName);
	}
	// For other elements, forward all props
	return true;
}

const StyleSheetManagerProvider = ({ children }) => (
	// enableVendorPrefixes is needed for backdrop property on safari
	<StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
		{children}
	</StyleSheetManager>
);

export default StyleSheetManagerProvider;
